import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Input from '../../components/UI/Input';
import Button from '../../components/UI/Button';
import { CompanyContext } from '../../context/CompanyContext';

export default function CompanyLogin() {
	const { loginCompany, loading } = useContext(CompanyContext);
	const navigate = useNavigate();
	const [form, setForm] = useState({ email: '', password: '' });

	function onChange(e) {
		setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
	}

	async function onSubmit(e) {
		e.preventDefault();
		const ok = await loginCompany(form.email, form.password);
		if (ok) navigate('/company/dashboard');
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-blue-50 px-4">
			<div className="w-full max-w-md bg-white shadow rounded-lg p-6 border border-blue-100">
				<h1 className="text-2xl font-bold text-center text-blue-700">Company Login</h1>
				<form className="mt-6 space-y-4" onSubmit={onSubmit}>
					<Input name="email" label="Company Email" value={form.email} onChange={onChange} required />
					<Input name="password" type="password" label="Password" value={form.password} onChange={onChange} required />
					<Button type="submit" loading={loading} className="w-full" variant="secondary">
						Login
					</Button>
				</form>
				<div className="mt-4 text-sm text-center">
					<Link to="/forgot-password" className="text-blue-600 hover:underline">
						Forgot password?
					</Link>
				</div>
				<p className="mt-4 text-sm text-center">
					New to Resumly?{' '}
					<Link to="/company/register" className="text-blue-600 hover:underline">
						Register your company
					</Link>
				</p>
			</div>
		</div>
	);
}


